import './image-video.scss';
import Swiper from 'swiper/bundle';

export default () => {
	//Swiper
	new Swiper('.js-image-video-slider', {
		speed: 1000,
		loop: true,
		slidesPerView: 1,
		effect: 'fade',
		autoplay: {
			delay: 3000,
		},
	});
};
